import form from './form/state';

// -------------------------------------------------

const state = {
  form,
};

export default state;
